import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/position-moves", data);
}

async function fetchOne(id,data) {
    return Request('get', "api/position-moves/" + id, data);
}

async function stockMaterialPosition(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/stock-material-positions" , data);
}

async function addPreview(data) {// 新建移库单预览
    return Request('post', "api/position-moves/add-view", data);
}

async function addMovePositionOrder (data) {
    return Request('patch', "api/position-moves/add" , data)
}

async function editPreview(data) {// 新建移库单预览
    return Request('post', "api/position-moves/edit-view", data);
}

async function editMovePositionOrder (data) {
    return Request('patch', "api/position-moves/edit" , data)
}

async function autoPositionReplenishList(data) {//自动移库商品列表
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('patch', "api/position-moves/position_replenish" , data);
}

async function autoPositionReplenishMoveList(data) {//自动移库创建详情
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('patch', "api/position-moves/get_replenish_move_list" , data);
}

async function shelveOff(data) {//移库单下架
    return Request('patch', "api/position-moves/shelve-off" , data)
}

async function shelveOn(data) {//移库单上架
    return Request('patch', "api/position-moves/shelve-on" , data)
}

async function cancel(id) {
    return Request('get', "api/position-moves/cancel/" + id);
}

async function getMaterialPositionBatch(data) {//获取商品的库位批次
    return Request('get', "api/stock-material-positions/view-by-material-and-position",data)
}

export default {
    fetch,
    fetchOne,
    stockMaterialPosition,
    addMovePositionOrder,
    addPreview,
    autoPositionReplenishList,
    autoPositionReplenishMoveList,
    editPreview,
    editMovePositionOrder,
    shelveOff,
    shelveOn,
    cancel,
    getMaterialPositionBatch,
};